import { createJSONStorage, persist } from 'zustand/middleware'
import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'

type NavigationStoreType = {
  isOpen: boolean
  isHidden: boolean
  isHovered: boolean
  hoverTimeoutId: number | null
}

const initialState: NavigationStoreType = {
  isOpen: true,
  isHidden: false,
  isHovered: true,
  hoverTimeoutId: null
}

const useStore = createWithEqualityFn(
  persist<NavigationStoreType>(() => initialState, {
    name: 'sideNavigationStore',
    storage: createJSONStorage(() => localStorage)
  }),
  shallow
)

export const sideNavigationStore = {
  setIsOpen: (isOpen: boolean): void => {
    useStore.setState({ isOpen })
  },
  setIsHidden: (isHidden: boolean): void => {
    useStore.setState({ isHidden })
  },
  setIsHovered: (isHovered: boolean): void => {
    useStore.setState({ isHovered })
  },
  startHoverHide: (delay: number = 500): void => {
    const currentTimeoutId = useStore.getState().hoverTimeoutId

    if (currentTimeoutId !== null) {
      window.clearTimeout(currentTimeoutId)
    }

    const timeoutId = window.setTimeout(() => {
      useStore.setState({ isHovered: false, hoverTimeoutId: null })
    }, delay)

    useStore.setState({ hoverTimeoutId: timeoutId })
  },
  cancelHoverHide: (): void => {
    const currentTimeoutId = useStore.getState().hoverTimeoutId
    if (currentTimeoutId !== null) {
      window.clearTimeout(currentTimeoutId)
      useStore.setState({ hoverTimeoutId: null })
    }
  },

  clearStore: (): void => {
    const currentTimeoutId = useStore.getState().hoverTimeoutId
    if (currentTimeoutId !== null) {
      window.clearTimeout(currentTimeoutId)
    }
    useStore.setState(initialState)
  },
  useStore
}
